import React, { useState } from 'react';
import { Box, Typography, Button } from '@mui/material';
import { NavLink } from 'react-router-dom';
import lockIcon from './assets/locked.png';
import unlockIcon from './assets/unlock.png';
import unlockWhite from './assets/unlock-white.png';

const LockButton = ({ isLocked, isDoc1 }) => {
  const [showModal, setShowModal] = useState(false);

  const isWhiteUnlock = !isLocked && isDoc1;
  const iconSrc = isLocked
    ? lockIcon
    : isWhiteUnlock
    ? unlockWhite
    : unlockIcon;

  const handleClick = () => {
    setShowModal(true);
    setTimeout(() => setShowModal(false), 4000); // auto-close after a bit
  };

  return (
    <>
      <button
        onClick={handleClick}
        style={{
          background: 'none',
          border: 'none',
          padding: 0,
          cursor: 'pointer',
        }}
        type="button"
        title="Premium feature. Please subscribe."
        aria-label={isLocked ? 'Unlock' : 'Lock'}
      >
        <img
          src={iconSrc}
          alt={isLocked ? 'Locked' : 'Unlocked'}
          style={{
            width: isWhiteUnlock ? '24px' : '16px',
            height: 'auto',
            display: 'block',
          }}
        />
      </button>

      {showModal && (
       <Box
        sx={{
          position: 'fixed',
          top: '39%',
          left: '69%',
          transform: 'translate(-100%, -50%) scale(1)',
          bgcolor: '#fff',
          color: '#49a7ab',
          borderRadius: 2,
          boxShadow: 5,
          p: 1.5,
          zIndex: 9999,
          textAlign: 'center',
          minWidth: 500,
          whiteSpace: 'nowrap',
          animation: 'popout 0.2s ease',
        }}
      >
        <Typography
          variant="body1"
          sx={{ mb: 1, whiteSpace: 'nowrap', fontWeight: 500,  }}
        >
          Premium Functionality
        </Typography>
        <NavLink to="/accounts" style={{ textDecoration: 'none' }}>
          <Button
            variant="contained"
            sx={{
              bgcolor: '#49a7ab',
              color: '#fff',
              fontWeight: 600,
              fontSize: '.875rem',
              '&:hover': { bgcolor: '#42999d' },
            }}
          >
            Subscribe
          </Button>
        </NavLink>
        <style>
          {`
            @keyframes popout {
              0% { transform: translate(-100%, -50%) scale(0.7); opacity: 0; }
              100% { transform: translate(-100%, -50%) scale(1); opacity: 1; }
            }
          `}
        </style>
      </Box>
      )}
    </>
  );
};

export default LockButton;
